import { Suspense, useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Navbar from "../title-bar/Navbar";
import FallbackUI from "../fallback-ui/FallbackUI";
import AppBootstrapper from "../common/AppBootstrapper";
import Admin from "../admin/AdminComponent";
import { Box } from "@mui/material";
import { useLogout } from "../../hooks/useLogout";
import { setLogoutHandler } from "../../services";

export const MainLayout: React.FC = () => {
  const { isAuthenticated, canManageUsers } = useAuth();
  const { logout } = useLogout();

  const [queryParams, setQueryParams] = useSearchParams();
  const admin = queryParams.get("admin");

  // initialize logout handler so that consumers (such as axios interceptor) can
  // access as soon as authenticated routes are available
  useEffect(() => {
    if (logout) {
      setLogoutHandler(logout);
    }

    return () => {
      setLogoutHandler(null);
    };
  }, []);

  const handleCloseAdminSetttings = () => {
    const params = new URLSearchParams(queryParams);
    params.delete("admin");
    setQueryParams(params);
  };

  return (
    <div className='main-layout'>
      {/* Show the admin settings page — only for users with admin permission */}
      {admin === "true" && canManageUsers && <Admin onClose={handleCloseAdminSetttings} />}

      {/* Bootstrap application state from URL query params */}
      <AppBootstrapper />

      {/* For the time being, hide the Navbar for the index route as we are showing APPContent, which gonna be replace with Home later */}
      {isAuthenticated && <Navbar />}
      <Box className='content-area' sx={{ backgroundColor: "grey.700" }}>
        <Suspense fallback={<FallbackUI />}>
          <Outlet />
        </Suspense>
      </Box>
    </div>
  );
};
